import { useEffect, useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import UnitSelector from '../BaseComponents/UnitSelector';
import ColorPicker from './ColorPicker';
import Slider from './Slider';
import { defaultProps, rgbToHex, hexToRgb } from './utils';

const splitShadowValues = (value: string) => {
    const values = value.split(' ');
    const offsets = values.length === 3 ? [values[0], values[1]] : ['0px', '0px'];
    const rgbValues = values.length === 3 ? values[2].match(/[+-]?\d+(\.\d+)?/g) : [];
    const _color =
        rgbValues?.length === 4
            ? rgbToHex(parseInt(rgbValues[0]), parseInt(rgbValues[1]), parseInt(rgbValues[2]))
            : '';
    const _opacity =
        rgbValues?.length === 4 ? `${(parseFloat(rgbValues[3]) * 100).toFixed(0)}%` : '100%';

    return { offsets, _color, _opacity };
};

const Shadow = (props: WidgetProps) => {
    const { schema, value, onChange } = props;
    const defaultValues =
        typeof schema.default === 'string' ? schema.default.split(' ') : ['0px', '0px'];
    const { offsets, _color, _opacity } = splitShadowValues(value);
    const [offsetX, setOffsetX] = useState(offsets[0]);
    const [offsetY, setOffsetY] = useState(offsets[1]);
    const [color, setColor] = useState(_color);
    const [opacity, setOpacity] = useState(_opacity);

    useEffect(() => {
        const values = color && hexToRgb(color);
        const a = parseInt(opacity.replace('%', '')) / 100;

        if (values && Object.keys(values).length === 3 && offsetX && offsetY) {
            const value = `${offsetX} ${offsetY} rgba(${values.r},${values.g},${values.b},${a})`;
            onChange(value);
        }
    }, [offsetX, offsetY, color, opacity, onChange]);

    const colorPickerProps: WidgetProps = {
        ...defaultProps,
        schema: {
            ...defaultProps.schema,
            title: 'Shadow Color',
        },
        value: color,
        onChange: (v: string) => setColor(v),
    };

    const sliderProps: WidgetProps = {
        ...defaultProps,
        schema: {
            ...defaultProps.schema,
            title: 'Shadow Opacity',
        },
        value: `${opacity}`,
        onChange: (v: string) => setOpacity(v),
    };

    return (
        <div className="shadow-container">
            <p className="shadow-label">{schema.title}</p>
            <ColorPicker {...colorPickerProps} />
            <div className="shadow-offsets">
                <p className="shadow-offsets-label">{'Shadow Offset'}</p>
                <div className="shadow-offsets-selectors">
                    <UnitSelector
                        value={offsetX}
                        defaultValue={defaultValues[0]}
                        onChange={(v) => setOffsetX(v)}
                        sideLabel={'X'}
                    />
                    <UnitSelector
                        value={offsetY}
                        defaultValue={defaultValues[1]}
                        onChange={(v) => setOffsetY(v)}
                        sideLabel={'Y'}
                    />
                </div>
            </div>
            <Slider {...sliderProps} />
        </div>
    );
};

export default Shadow;
